import { render, staticRenderFns } from "./diaobo.vue?vue&type=template&id=7553834a&scoped=true&"
import script from "./diaobo.vue?vue&type=script&lang=js&"
export * from "./diaobo.vue?vue&type=script&lang=js&"
import style0 from "./diaobo.vue?vue&type=style&index=0&id=7553834a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7553834a",
  null
  
)

export default component.exports